"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adherev_util_1 = __importDefault(require("@baifendian/adherev-util"));
var resource_1 = __importDefault(require("./resource"));
var withVue = adherev_util_1.default._util.withVue;
resource_1.default.install = function (app) {
    withVue(app, 'Resource', resource_1.default);
    return app;
};
exports.default = resource_1.default;
